import type { ICampaign } from '@/Module/DefaultLayout/Model';
import { useGetCampaignQuery } from '@/Module/DefaultLayout/Store/Query';

export const useCampaign = () => {
  return useGetCampaignQuery(undefined, {
    selectFromResult: result => {
      const data = result.data as ICampaign;

      return {
        bannerEnabled: data ? data.banner : false,
        popup: data ? data.popup : null,
        desktopBanner: data ? data.desktop.banner : null,
        desktopPopup: data ? data.desktop.popup : null,
        mobileBanner: data ? data.mobile.banner : null,
        mobilePopup: data ? data.mobile.popup : null,
        blackList: data ? data.popup.blackList : [],
      };
    },
  });
};
